import React, { Suspense, useEffect, useLayoutEffect, useState } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "../styles/common.scss";
import MainRoutes from "../utils/RoutesDetails";

const ScrollToTop = (props) => {
  const location = useLocation();

  useLayoutEffect(() => {
    if (!location.pathname.startsWith("/dashboard/user-profile")) {
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);

  return <>{props.children}</>;
};

const App = () => {
  const [userToken, setUserToken] = useState("");

  useEffect(() => {
    setUserToken(window.localStorage.getItem("USER_ACCESS_TOKEN"));
  }, []);

  return (
    <Suspense fallback={null}>
      <BrowserRouter basename={"/co-operate"}>
        <ScrollToTop>
          <Routes>
            {MainRoutes?.map((route, index) => {
              return (
                <Route path={route?.path} key={index} element={route?.element}>
                  {route?.Children?.map((child, index) => {
                    return (
                      <Route
                        path={child?.path}
                        key={index}
                        element={child?.element}
                      >
                        {child.grandChildren?.map((grandChild, index) => {
                          return (
                            <Route
                              path={grandChild?.path}
                              key={index}
                              element={grandChild?.element}
                            />
                          );
                        })}
                      </Route>
                    );
                  })}
                </Route>
              );
            })}
          </Routes>
        </ScrollToTop>
      </BrowserRouter>
    </Suspense>
  );
};

export default App;
